import { Component, inject, InjectionToken } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import FieldsConstants from 'src/app/common/fields.constants';
import { MessageLevel, SendEmailDialogData } from 'src/app/interfaces/dialog.interface';
import { DialogActionTypes } from 'src/app/notifications/dialogs/dialogs.enum';
import { NotificationState } from 'src/app/notifications/notifications.state';
import { ValidationService } from 'src/app/services/validation.service';

export const SEND_EMAIL_DIALOG_DATA = new InjectionToken<SendEmailDialogData>(`SEND_EMAIL_DIALOG_DATA`);

@Component({
  selector: 'app-dialog-send-reactivation-request',
  templateUrl: './dialog-send-reactivation-request.component.html',
  styleUrls: ['./dialog-send-reactivation-request.component.scss'],
})
export class DialogSendReactivationPetitionComponent extends NotificationState {
  protected notificationLevel: MessageLevel = 'INFO';

  public confirmActionButton: string = DialogActionTypes.CONFIRM_ACTION;

  public maxRequestLength = FieldsConstants.REACTIVATION_PETITION_MAX_LENGTH;

  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);
  public readonly modalArguments = inject(SEND_EMAIL_DIALOG_DATA);
  public readonly requestDescription: FormControl<string> = new FormControl('', {
    nonNullable: true,
    validators: [
      Validators.required,
      Validators.minLength(0),
      Validators.maxLength(this.maxRequestLength),
      ...inject(ValidationService).getValidators('noWhiteSpacesOnly'),
    ],
  });

  public actionsHandler(action: DialogActionTypes): void {
    this.dialogActions[action]();
  }

  public submit(): void {
    this.confirmAction();
  }

  public override confirmAction(): void {
    if (!this.isValid) {
      return;
    }

    this.activeModal.close({
      email: this.modalArguments.email,
      description: this.requestDescription.value,
    });
  }

  public get isValid(): boolean {
    return this.requestDescription.valid;
  }

  public onBlur(): void {
    this.requestDescription.setValue((this.requestDescription.value || '').trim());
  }
}
